// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img2/pay_top_main_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/img2/pay_top_title_select.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slSYbgCh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  overflow: visible;
  background-color: transparent;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}
.slSYbgCh::before,
.slSYbgCh::after {
  content: '';
  position: absolute;
  top: 0;
  pointer-events: none;
}
.slSYbgCh::before {
  left: 0;
  z-index: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) left top / auto 100% no-repeat;
}
.slSYbgCh::after {
  right: 0;
  z-index: 1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: calc(100% / (1 - 0.8)) 100%;
  background-position: right top;
}
@media (max-width: 767px) {
  .slSYbgCh {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    height: auto;
    min-height: 3.125rem;
    padding: 0.5rem 0;
    overflow: hidden;
    width: 100%;
    max-width: 100vw;
  }
  .slSYbgCh::before {
    height: calc(3.125rem * 110 / 104);
    width: calc(3.125rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(3.125rem * 328 / 104 - 2px);
    height: 3.125rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .slSYbgCh {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    height: 5rem;
  }
  .slSYbgCh::before {
    height: calc(5rem * 110 / 104);
    width: calc(5rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(5rem * 328 / 104 - 2px);
    height: 5.3rem;
  }
}
@media (min-width: 1024px) {
  .slSYbgCh {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    height: 5rem;
  }
  .slSYbgCh::before {
    height: calc(5rem * 110 / 104);
    width: calc(5rem * 328 / 104 + 2px);
  }
  .slSYbgCh::after {
    left: calc(5rem * 328 / 104 - 2px);
    height: 5.3rem;
  }
}
.VjeZst5L {
  position: relative;
  background: #f5f5f5;
  padding: 0.5rem;
  padding-top: 4.375rem;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .VjeZst5L {
    display: none;
  }
}
@media (min-width: 768px) {
  .VjeZst5L.z8MR9HQQ {
    display: none;
  }
}
@media (min-width: 768px) {
  .VjeZst5L.dG2Qxs0k {
    display: none;
  }
}
@media (max-width: 767px) {
  .VjeZst5L.a_eZ1XUE {
    display: none;
  }
}
@media (max-width: 767px) {
  .VjeZst5L.yb7OA2X7 {
    display: none;
  }
}
@media (min-width: 1024px) {
  .VjeZst5L {
    position: absolute;
    top: 14vw;
    left: 1%;
    z-index: 999;
    width: 98%;
    margin: 0 auto;
    border-radius: 1rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    padding: 0 2rem;
    padding-top: 0;
    height: 7rem;
  }
}
.BtEycIWT {
  width: 100%;
}
.Y4OQJmfp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}
@media (max-width: 767px) {
  .Y4OQJmfp {
    gap: 0.5rem;
  }
}
.zHIhM57O {
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 767px) {
  .zHIhM57O {
    width: 3rem;
    height: 3rem;
  }
}
@media (min-width: 1024px) {
  .zHIhM57O {
    width: 5rem;
    height: 5rem;
    border-radius: 1rem;
  }
}
.OTNvIQ1p {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 0.5rem;
}
.GDmL5IO3 {
  width: 100%;
  height: 100%;
}
.sVB5c3uo {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
}
.WfBlVulO {
  display: none;
}
@media (min-width: 1024px) {
  .WfBlVulO {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: #585858;
    margin-bottom: 0.25rem;
  }
}
.qN8X9qUM {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  width: 100%;
}
.o75QkgKG {
  color: #585858;
  font-size: 0.875rem;
}
@media (max-width: 767px) {
  .o75QkgKG {
    font-size: 0.4625rem;
  }
}
.d5JyeBW_ {
  color: #1890ff;
  font-size: 0.875rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.d5JyeBW_:hover {
  opacity: 0.8;
}
.d5JyeBW_:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .d5JyeBW_ {
    font-size: 0.75rem;
  }
}
.p7ZdYuU7 {
  display: inline-block;
  width: auto;
  height: 1em;
  vertical-align: middle;
  margin-left: 0.25rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.p7ZdYuU7:hover {
  opacity: 0.8;
}
.p7ZdYuU7:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .p7ZdYuU7 {
    height: 1rem;
    margin-left: 0.25rem;
  }
}
.iJmvZ14p {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  -webkit-flex-wrap: wrap;
          flex-wrap: wrap;
  font-size: 0.875rem;
}
.SGn_HB4s {
  color: #1890ff;
  cursor: pointer;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
}
.SGn_HB4s:hover {
  color: #0076e4;
}
.GwNgdG1L {
  color: #666666;
  font-size: 0.875rem;
}
@media (max-width: 767px) {
  .GwNgdG1L {
    font-size: 0.875rem;
  }
}
.sLKWM0Wj {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 0.125rem 0.25rem;
  background: transparent;
  border: none;
  color: #1890ff;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}
.sLKWM0Wj:hover {
  opacity: 0.8;
}
.sLKWM0Wj:active {
  opacity: 0.6;
}
@media (max-width: 767px) {
  .sLKWM0Wj {
    padding: 0.0625rem 0.25rem;
  }
}
.UA1ikLgE {
  position: relative;
  z-index: 2;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  margin: 0 auto;
  gap: 1.5rem;
}
@media (max-width: 767px) {
  .UA1ikLgE {
    padding: 0 0.5rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
            flex: 1;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    gap: 0.375rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .UA1ikLgE {
    padding: 1rem 1.25rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
  }
}
@media (min-width: 1024px) {
  .UA1ikLgE {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    padding: 1.5rem 1rem;
    width: 100%;
  }
}
._fyIi7KJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  min-width: 0;
}
@media (max-width: 767px) {
  ._fyIi7KJ {
    min-width: 0;
  }
}
.sbCrta3X {
  text-decoration: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  min-width: 0;
}
@media (max-width: 767px) {
  .sbCrta3X {
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    gap: 0.25rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .sbCrta3X {
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 1024px) {
  .sbCrta3X {
    gap: 1.5rem;
  }
}
.bPFeSkuu {
  height: 2.25rem;
  width: auto;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .bPFeSkuu {
    height: 1.875rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .bPFeSkuu {
    height: 2.25rem;
  }
}
@media (min-width: 1024px) {
  .bPFeSkuu {
    height: 4rem;
  }
}
.aYCUJo6Z {
  height: 1.5rem;
  width: auto;
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .aYCUJo6Z {
    width: 4.263rem;
    max-width: 4.263rem;
    height: auto;
    max-height: 1rem;
    -webkit-align-self: flex-start;
            align-self: flex-start;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .aYCUJo6Z {
    width: 5.61rem;
    max-width: 5.61rem;
    height: auto;
    max-height: 1.25rem;
    -webkit-align-self: flex-start;
            align-self: flex-start;
  }
}
@media (min-width: 1024px) {
  .aYCUJo6Z {
    width: auto;
    height: 1.625rem;
    max-height: none;
    margin-top: 0;
    -webkit-align-self: center;
            align-self: center;
  }
}
.YEXthgKT {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 1.5rem;
}
@media (max-width: 1023px) {
  .YEXthgKT {
    position: fixed;
    top: 3.75rem;
    left: 0;
    right: 0;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
            flex-direction: column;
    background: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    -webkit-transform: translateX(-100%);
            transform: translateX(-100%);
    -webkit-transition: -webkit-transform 0.3s ease;
    transition: -webkit-transform 0.3s ease;
    transition: transform 0.3s ease;
    transition: transform 0.3s ease, -webkit-transform 0.3s ease;
    gap: 0;
    z-index: 1000;
    padding: 0.25rem 0;
  }
  .YEXthgKT.Mg_ORDaH {
    -webkit-transform: translateX(0);
            transform: translateX(0);
  }
}
@media (min-width: 1024px) {
  .YEXthgKT {
    display: none;
  }
}
.NRbCIQNp {
  color: #585858;
  text-decoration: none;
  font-size: 1rem;
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
}
.NRbCIQNp:hover {
  color: #1890ff;
}
@media (max-width: 767px) {
  .NRbCIQNp {
    text-align: center;
    margin: 0 auto;
    border-bottom: 1px solid #e8e8e8;
    width: 70%;
    padding: 1rem 1.5rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    font-size: 0.875rem;
    gap: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .NRbCIQNp {
    text-align: center;
    margin: 0 auto;
    border-bottom: 1px solid #e8e8e8;
    width: 70%;
    padding: 1rem 1.5rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
            justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    font-size: 0.875rem;
    gap: 1rem;
  }
}
.NRbCIQNp:last-child {
  border-bottom: none;
}
.o_dTFhV5 {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  color: inherit;
}
@media (max-width: 767px) {
  .o_dTFhV5 {
    width: 1.25rem;
    height: 1.25rem;
  }
}
.s4NCMenQ {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
          flex: 0 0 auto;
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.WxmOruAL {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  min-width: 0;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .WxmOruAL {
    gap: 0.25rem;
    max-width: 48%;
  }
}
.TWzNkum5 {
  display: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  gap: 1rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
          justify-content: flex-end;
  padding-right: 2rem;
}
@media (min-width: 1024px) {
  .TWzNkum5 {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    margin-left: 1.5rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .TWzNkum5 {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    margin-left: 1.5rem;
    padding-right: 1rem;
  }
}
@media (max-width: 767px) {
  .TWzNkum5 {
    display: none;
  }
}
.Cfpkiz5W {
  border: none;
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  color: rgba(255, 255, 255, 0.82);
  font-family: 'JingNan BoBo Hei', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1rem;
  text-decoration: none;
  padding: 0;
  cursor: pointer;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
  font-weight: bold;
  font-size: 1.125rem;
}
@media (max-width: 767px) {
  .Cfpkiz5W {
    display: none;
  }
}
.Cfpkiz5W:hover {
  color: #1890ff;
}
.Cfpkiz5W.x1_I8CNw {
  color: #ff6c00;
  font-size: 1.7rem;
  margin-right: 1.5rem;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .Cfpkiz5W.x1_I8CNw {
    display: none;
  }
}
@media (min-width: 1024px) {
  .Cfpkiz5W.x1_I8CNw {
    display: none;
  }
}
.Cfpkiz5W.x1_I8CNw:hover {
  color: #ff6c00;
  opacity: 0.9;
}
.Cfpkiz5W._9tAt3YC:hover {
  color: rgba(255, 255, 255, 0.95);
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r {
  color: #feba34;
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r:hover {
  color: #feba34;
  opacity: 0.92;
}
.Cfpkiz5W._9tAt3YC.BY_mTe0r::after {
  content: '';
  position: absolute;
  bottom: -0.375rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 3.5625rem;
  height: 0.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
}
.UELox73u {
  width: 3px;
  height: 1.125rem;
  background: rgba(255, 255, 255, 0.35);
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  margin: 0 0.25rem;
  border-radius: 4px;
}
.YxQQ0tvE {
  display: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 0.5rem 1.5rem;
  background-color: #ff8f1d;
  color: #ffffff;
  border-radius: 999px;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease, background-color 0.2s ease;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}
.YxQQ0tvE:hover {
  opacity: 0.9;
}
.YxQQ0tvE:active {
  opacity: 0.8;
}
@media (min-width: 1024px) {
  .YxQQ0tvE {
    display: block;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .YxQQ0tvE {
    display: block;
  }
}
.DrhfkESi {
  display: none;
  position: relative;
  min-width: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
          align-items: stretch;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .DrhfkESi {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    min-width: 12rem;
    max-width: 18rem;
  }
}
@media (min-width: 1024px) {
  .DrhfkESi {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    min-width: 14rem;
    max-width: 20rem;
  }
}
@media (max-width: 767px) {
  .ACcRgdGU {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    position: relative;
    max-width: 42vw;
    min-width: 0;
  }
}
@media (max-width: 767px) {
  .BZjvUcHB {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    position: relative;
    max-width: 48vw;
    min-width: 0;
  }
}
.onBSJRgN .amrPemvn {
  border-radius: 0.75rem 0.75rem 0 0;
  border-bottom-color: transparent;
}
.amrPemvn {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  gap: 0.375rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.75rem;
  background-color: #3c302a;
  border: 1px solid #9c8466;
  border-radius: 0.75rem;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
.amrPemvn:hover {
  background-color: #483a32;
}
@media (max-width: 767px) {
  .amrPemvn {
    padding: 0.5rem 0.625rem;
    gap: 0.25rem;
  }
}
.FX3bc5nT {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
@media (max-width: 767px) {
  .FX3bc5nT {
    font-size: 0.625rem;
  }
}
@media (min-width: 1024px) {
  .FX3bc5nT {
    font-size: 1rem;
  }
}
.DFFBVVPO {
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  width: 0.875rem;
  height: 0.875rem;
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
@media (max-width: 767px) {
  .DFFBVVPO {
    width: 0.75rem;
    height: 0.75rem;
  }
}
.LnJ91sL2 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.gr1jL_46 {
  margin-top: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #3c302a;
  border: 1px solid #9c8466;
  border-top: none;
  border-radius: 0 0 0.75rem 0.75rem;
  box-shadow: none;
  overflow: hidden;
}
.ks3Nw2XX {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 100%;
  z-index: 1001;
}
.eTBjKnGi {
  position: fixed;
  z-index: 1002;
  min-width: 0;
  max-width: none;
}
.NNNXQaBb {
  height: 1px;
  margin: 0;
  background-color: #9c8466;
}
.DB7hJh15 {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.75rem;
  text-align: center;
  font-family: 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
.DB7hJh15:hover {
  background-color: #4e3e37;
}
.DB7hJh15:active {
  background-color: #5a483f;
}
@media (max-width: 767px) {
  .DB7hJh15 {
    padding: 0.5rem 0.625rem;
    font-size: 0.75rem;
  }
}
.ct51z5xU {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
          align-items: flex-start;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
  width: auto;
  max-width: 4.263rem;
  min-width: 0;
  vertical-align: middle;
  -webkit-align-self: center;
          align-self: center;
}
@media (max-width: 767px) {
  .ct51z5xU {
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
            align-items: flex-start;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    height: 1.875rem;
    text-align: left;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .ct51z5xU {
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
            align-items: flex-start;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    height: 2.25rem;
    text-align: left;
    max-width: 5.61rem;
  }
}
@media (min-width: 1024px) {
  .ct51z5xU {
    height: auto;
    max-width: none;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
            flex-direction: row;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    gap: 0.625rem;
  }
}
.CMWFVjrY {
  display: none;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin-top: 0.125rem;
  overflow: visible;
}
@media (max-width: 767px) {
  .CMWFVjrY {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
            align-items: flex-end;
    margin-top: auto;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .CMWFVjrY {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
            align-items: flex-end;
    margin-top: auto;
  }
}
@media (min-width: 1024px) {
  .CMWFVjrY {
    display: block;
    width: auto;
    min-width: 0;
    margin-top: 0;
    margin-left: 0.75rem;
    overflow: visible;
  }
}
.SaCm9NPx {
  display: block;
  box-sizing: border-box;
  max-width: 100%;
  color: #fa5900;
  font-family: "JingNan BoBo Hei";
  white-space: nowrap;
  text-align: left;
  line-height: 1.15;
  overflow: visible;
}
@media (max-width: 767px) {
  .SaCm9NPx {
    font-size: 0.725rem;
    font-weight: 700;
    line-height: 1;
    -webkit-align-self: flex-end;
            align-self: flex-end;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .SaCm9NPx {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.05;
    -webkit-align-self: flex-end;
            align-self: flex-end;
  }
}
@media (min-width: 1024px) {
  .SaCm9NPx {
    width: auto;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.2;
  }
}
.AGbYZKGl {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: normal;
}
.jMVNYpxK {
  background-color: #2c2c2c;
}
@media (max-width: 767px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .o6H1hQYt {
    color: #ff8a16;
  }
}
@media (max-width: 767px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .ucMM2ewT {
    background: rgba(255, 255, 255, 0.35);
  }
}
@media (max-width: 767px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (min-width: 1024px) {
  .jMVNYpxK .WxmOruAL {
    margin-left: auto;
    -webkit-flex-shrink: 0;
            flex-shrink: 0;
  }
}
@media (max-width: 767px) {
  .eEHixaFV .YxQQ0tvE {
    display: block !important;
    padding: 0.375rem 1.125rem;
    font-size: 0.75rem;
    font-weight: 700;
    background-color: #ff8a16;
    border-radius: 999px;
    white-space: nowrap;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .eEHixaFV .YxQQ0tvE {
    display: block !important;
    padding: 0.4375rem 1.25rem;
    font-size: 0.875rem;
    font-weight: 700;
    background-color: #ff8a16;
    border-radius: 999px;
    white-space: nowrap;
  }
}
@media (max-width: 767px) {
  .EI64mGw6 {
    gap: 0.625rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .EI64mGw6 {
    gap: 1rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 1024px) {
  .EI64mGw6 {
    gap: 1rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
.FjAMRuJf {
  background-color: #000;
}
@media (max-width: 767px) {
  .tflBBnun {
    gap: 0.825rem;
    width: 100%;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .tflBBnun {
    gap: 1rem;
  }
}
@media (min-width: 1024px) {
  .tflBBnun {
    gap: 1rem;
  }
}
@media (max-width: 767px) {
  .e9m4cALT {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
            justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    gap: 0.5rem;
  }
}
.e9m4cALT ._fyIi7KJ {
  -webkit-box-flex: 0;
  -webkit-flex: 0 1 auto;
          flex: 0 1 auto;
  min-width: 0;
}
.e9m4cALT .WxmOruAL {
  margin-left: auto;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 413px) {
  .e9m4cALT .bPFeSkuu {
    height: 1.875rem;
  }
  .e9m4cALT .aYCUJo6Z {
    max-height: 1rem;
  }
  .e9m4cALT .SaCm9NPx {
    font-size: 0.625rem;
  }
}
@media (max-width: 767px) {
  .LfDJxVwX {
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
  }
}
.bgBpjEza {
  display: none;
}
@media (max-width: 767px) {
  .bgBpjEza {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
            align-items: center;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    gap: 0.575rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0;
            flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    padding-bottom: 0.4375rem;
  }
}
@media (max-width: 767px) {
  .l4s972Zf {
    padding-bottom: 0;
  }
}
@media (max-width: 399px) {
  .bnA1G1WJ .UA1ikLgE {
    gap: 0.575rem;
    min-width: 0;
  }
  .bnA1G1WJ ._fyIi7KJ {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
            flex: 0 0 auto;
    min-width: 0;
  }
  .bnA1G1WJ .bPFeSkuu {
    height: 1.625rem;
  }
  .bnA1G1WJ .aYCUJo6Z {
    width: 3.73rem;
    max-width: 3.73rem;
    max-height: 0.875rem;
  }
  .bnA1G1WJ .ct51z5xU {
    max-width: 3.73rem;
    height: 1.625rem;
  }
  .bnA1G1WJ .SaCm9NPx {
    font-size: 0.5625rem;
    line-height: 1;
  }
  .bnA1G1WJ .bgBpjEza {
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0;
            flex: 1 1 0;
    gap: 0.6125rem;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
            justify-content: flex-start;
    overflow: hidden;
    padding-bottom: 0.4375rem;
  }
  .bnA1G1WJ .l4s972Zf {
    padding-bottom: 0;
  }
  .bnA1G1WJ .TpiKZ7KT {
    font-size: 0.625rem;
  }
  .bnA1G1WJ .ucMM2ewT {
    height: 0.75rem;
  }
  .bnA1G1WJ .WxmOruAL {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
            flex: 0 0 auto;
    margin-left: auto;
    min-width: 0;
    max-width: 42%;
  }
  .bnA1G1WJ .BZjvUcHB,
  .bnA1G1WJ .ACcRgdGU {
    max-width: 100%;
  }
  .bnA1G1WJ .amrPemvn {
    padding: 0.375rem 0.5rem;
  }
  .bnA1G1WJ .FX3bc5nT {
    font-size: 0.5625rem;
  }
}
.TpiKZ7KT {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: relative;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-box-flex: 0;
  -webkit-flex: 0 1 auto;
          flex: 0 1 auto;
  min-width: 0;
  max-width: calc((100% - 0.25rem - 1px) / 2);
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  -webkit-transition: opacity 0.2s ease, color 0.2s ease;
  transition: opacity 0.2s ease, color 0.2s ease;
}
.TpiKZ7KT:hover {
  opacity: 0.85;
}
.Okp1w76E {
  position: relative;
  display: inline-block;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  white-space: nowrap;
  line-height: 1.2;
  text-align: center;
}
.o6H1hQYt {
  color: #ff8a16;
}
.o6H1hQYt .Okp1w76E::after {
  content: '';
  position: absolute;
  bottom: -0.3375rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  width: 100%;
  height: 0.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
  pointer-events: none;
}
@media (max-width: 413px) {
  .o6H1hQYt .Okp1w76E::after {
    bottom: -0.4375rem;
  }
}
.ucMM2ewT {
  width: 1px;
  height: 0.875rem;
  background: rgba(255, 255, 255, 0.35);
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .WcW8I6HY {
    display: block !important;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .WcW8I6HY {
    display: block !important;
  }
}
@media (max-width: 1023px) {
  .kcKlUkRc {
    display: none !important;
  }
}
.FmYnbzty {
  display: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  min-height: 2.75rem;
  min-width: 2.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  color: #ffffff;
  padding: 0.25rem;
}
@media (max-width: 767px) {
  .FmYnbzty {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }
}
@media (min-width: 1024px) {
  .FmYnbzty {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAYA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AAXF;AAaE;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,oBAAA;AAXJ;AAcE;EACE,OAAA;EACA,UAAA;EACA,kFAAA;AAZJ;AAeE;EACE,QAAA;EACA,UAAA;EACA,6DAAA;EACA,4CAAA;EACA,8BAAA;AAbJ;AC1BE;EAAA;ID2CE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;IACA,oBAAA;IACA,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAbF;EAeE;IACE,kCAAA;IACA,uCAAA;EAbJ;EAgBE;IACE,sCAAA;IACA,gBAAA;EAdJ;AACF;AClCE;EAAA;IDoDE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;EAdF;EAgBE;IACE,8BAAA;IACA,mCAAA;EAdJ;EAiBE;IACE,kCAAA;IACA,cAAA;EAfJ;AACF;AC3CE;EAAA;ID8DE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;EAfF;EAiBE;IACE,8BAAA;IACA,mCAAA;EAfJ;EAkBE;IACE,kCAAA;IACA,cAAA;EAhBJ;AACF;AAqBA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AAnBF;ACtEE;EAAA;ID6FE,aAAA;EAnBF;AACF;AC/DE;EAAA;IDsFI,aAAA;EAnBJ;AACF;ACpEE;EAAA;ID4FI,aAAA;EApBJ;AACF;ACjGE;EAAA;ID0HI,aAAA;EArBJ;AACF;ACtGE;EAAA;IDgII,aAAA;EAtBJ;AACF;ACzFE;EAAA;IDmHE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;IACA,cAAA;IACA,mBAAA;IACA,yCAAA;IACA,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EAtBF;AACF;AAyBA;EACE,WAAA;AAvBF;AA0BA;ECpFE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDoFA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,eAAA;AAvBF;ACtIE;EAAA;IDgKE,WAAA;EAtBF;AACF;AAyBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EAEA,sBAAA;UAAA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,wCAAA;AAxBF;ACvJE;EAAA;IDkLE,WAAA;IACA,YAAA;EAvBF;AACF;AC3IE;EAAA;IDoKE,WAAA;IACA,YAAA;IACA,mBAAA;EArBF;AACF;AAwBA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;KAAA,iBAAA;EACA,qBAAA;AAtBF;AAyBA;EACE,WAAA;EACA,YAAA;AAvBF;AA2BA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;EACA,kBAAA;AAzBF;AA4BA;EACE,aAAA;AA1BF;ACtKE;EAAA;IDmME,cAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;IACA,sBAAA;EAzBF;AACF;AA4BA;ECxJE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDwJA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,WAAA;AAzBF;AA4BA;EACE,cAAA;EACA,mBAAA;AA1BF;AC5ME;EAAA;IDyOE,oBAAA;EAzBF;AACF;AA4BA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA1BF;AA4BE;EACE,YAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;AC7NE;EAAA;ID4PE,kBAAA;EA3BF;AACF;AA8BA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA5BF;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;ACjPE;EAAA;IDkRE,YAAA;IACA,oBAAA;EA7BF;AACF;AAgCA;EClNE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDkNA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,uBAAA;UAAA,eAAA;EACA,mBAAA;AA7BF;AAgCA;EACE,cAAA;EAEA,eAAA;EACA,mCAAA;EAAA,2BAAA;AA/BF;AAiCE;EACE,cAAA;AA/BJ;AAoCA;EACE,cAAA;EACA,mBAAA;AAlCF;AC3QE;EAAA;IDgTE,mBAAA;EAjCF;AACF;AAoCA;EC/ME,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EAjDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;ED4PA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qCAAA;EAAA,6BAAA;AA5BF;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;ACtSE;EAAA;IDuUE,0BAAA;EA7BF;AACF;AAgCA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,cAAA;EACA,WAAA;AA9BF;ACnTE;EAAA;IDoVE,iBAAA;IACA,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,mBAAA;IAAA,eAAA;YAAA,OAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;IACA,sBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,aAAA;EA7BF;AACF;ACpTE;EAAA;IDmVE,qBAAA;IACA,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,WAAA;IACA,sBAAA;EA3BF;AACF;ACtTE;EAAA;IDoVE,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,oBAAA;IACA,WAAA;EA1BF;AACF;AA8BA;ECxSE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDwSA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,sBAAA;UAAA,cAAA;EACA,YAAA;AA3BF;ACtVE;EAAA;IDoXE,YAAA;EA1BF;AACF;AA6BA;EACE,qBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,YAAA;AA3BF;AClWE;EAAA;IDgYE,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,YAAA;EA1BF;AACF;AC5VE;EAAA;IDyXE,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EAzBF;AACF;AC3VE;EAAA;IDuXE,WAAA;EAxBF;AACF;AA2BA;EACE,eAAA;EACA,WAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AAzBF;ACzXE;EAAA;IDqZE,gBAAA;EAxBF;AACF;AClXE;EAAA;ID6YE,eAAA;EAvBF;AACF;ACjXE;EAAA;ID2YE,YAAA;EAtBF;AACF;AAyBA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AAvBF;AChZE;EAAA;ID0aE,eAAA;IACA,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,8BAAA;YAAA,sBAAA;EAtBF;AACF;AC7YE;EAAA;IDsaE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,mBAAA;IACA,8BAAA;YAAA,sBAAA;EArBF;AACF;AChZE;EAAA;IDwaE,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,0BAAA;YAAA,kBAAA;EApBF;AACF;AAuBA;EC7XE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED6XA,WAAA;AAnBF;AAsBE;EAAA;IACE,eAAA;IACA,YAAA;IACA,OAAA;IACA,QAAA;IACA,4BAAA;IAAA,6BAAA;IAAA,8BAAA;YAAA,sBAAA;IACA,mBAAA;IACA,yCAAA;IACA,oCAAA;YAAA,4BAAA;IACA,+CAAA;IAAA,uCAAA;IAAA,+BAAA;IAAA,4DAAA;IACA,MAAA;IACA,aAAA;IACA,kBAAA;EAnBF;EAqBE;IACE,gCAAA;YAAA,wBAAA;EAnBJ;AACF;AClbE;EAAA;IDycE,aAAA;EAnBF;AACF;AAsBA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,mGAAA;EACA,mCAAA;EAAA,2BAAA;EC/ZA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;ED+ZA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;AAnBF;AAqBE;EACE,cAAA;AAnBJ;AC5dE;EAAA;IDmfE,kBAAA;IACA,cAAA;IACA,gCAAA;IACA,UAAA;IACA,oBAAA;ICxYF,mBAAA;IACA,kBAAA;IDyYE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,mBAAA;IACA,SAAA;EAlBF;AACF;ACheE;EAAA;IDofE,kBAAA;IACA,cAAA;IACA,gCAAA;IACA,UAAA;IACA,oBAAA;ICrZF,mBAAA;IACA,kBAAA;IDsZE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,mBAAA;IACA,SAAA;EAfF;AACF;AAiBE;EACE,mBAAA;AAfJ;AAmBA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,sBAAA;UAAA,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAjBF;ACxgBE;EAAA;ID4hBE,cAAA;IACA,eAAA;EAhBF;AACF;AAmBA;EACE,mBAAA;EAAA,sBAAA;UAAA,cAAA;EACA,mGAAA;AAjBF;AAoBA;ECjeE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDieA,WAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,sBAAA;UAAA,cAAA;AAjBF;AC1hBE;EAAA;ID8iBE,YAAA;IACA,cAAA;EAhBF;AACF;AA6BA;EACE,aAAA;ECzfA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EAEA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EDyfA,SAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,qBAAA;EAAA,iCAAA;UAAA,yBAAA;EACA,mBAAA;AA1BF;ACxhBE;EAAA;IDqjBE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;EAzBF;AACF;ACriBE;EAAA;IDgkBE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,mBAAA;IACA,mBAAA;EAvBF;AACF;ACzjBE;EAAA;IDklBE,aAAA;EArBF;AACF;AAwBA;EClfE,YAAA;EACA,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;ED8eA,gCAAA;EACA,mGAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,mCAAA;EAAA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAlBF;AChlBE;EAAA;IDomBE,aAAA;EAhBF;AACF;AAkBE;EACE,cAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;AAjBJ;ACjlBE;EAAA;IDqmBI,aAAA;EAhBJ;AACF;AChlBE;EAAA;IDmmBI,aAAA;EAfJ;AACF;AAiBI;EACE,cAAA;EACA,YAAA;AAfN;AAoBI;EACE,gCAAA;AAlBN;AAqBI;EACE,cAAA;AAnBN;AAqBM;EACE,cAAA;EACA,aAAA;AAnBR;AAsBM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AApBR;AA0BA;EACE,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;UAAA,cAAA;EACA,iBAAA;EACA,kBAAA;AAxBF;AA4BA;EACE,aAAA;EChkBA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED4jBA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,iEAAA;EAAA,yDAAA;AArBF;AAwBE;EACE,YAAA;AAtBJ;AAyBE;EACE,YAAA;AAvBJ;AC3oBE;EAAA;IDqqBE,cAAA;EAtBF;AACF;ACtpBE;EAAA;ID+qBE,cAAA;EArBF;AACF;AA0BA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,0BAAA;EAAA,4BAAA;UAAA,oBAAA;AAxBF;AClqBE;EAAA;ID6rBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,gBAAA;IACA,gBAAA;EAvBF;AACF;ACnqBE;EAAA;ID6rBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,gBAAA;IACA,gBAAA;EAtBF;AACF;AC5rBE;EAAA;IDutBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,YAAA;EAvBF;AACF;ACpsBE;EAAA;IDguBE,2BAAA;IAAA,4BAAA;IAAA,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,YAAA;EAxBF;AACF;AA2BA;EACE,kCAAA;EACA,gCAAA;AAzBF;AA4BA;ECxoBE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDooBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,yBAAA;EAAA,sCAAA;UAAA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,8CAAA;EAAA,sCAAA;AArBF;AAuBE;EACE,yBAAA;AArBJ;ACvuBE;EAAA;IDgwBE,wBAAA;IACA,YAAA;EArBF;AACF;AAwBA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,+EAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAtBF;ACzvBE;EAAA;IDkxBE,mBAAA;EArBF;AACF;AC5uBE;EAAA;IDowBE,eAAA;EApBF;AACF;AAuBA;EACE,sBAAA;UAAA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,+CAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,4DAAA;AArBF;ACzwBE;EAAA;IDiyBE,cAAA;IACA,eAAA;EApBF;AACF;AAuBA;EACE,iCAAA;UAAA,yBAAA;AArBF;AAyBA;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AAvBF;AA2BA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AAzBF;AA6BA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AA3BF;AA8BA;EACE,WAAA;EACA,SAAA;EACA,yBAAA;AA5BF;AA+BA;EC3uBE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDuuBA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+EAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;EAAA,sCAAA;AAxBF;AA0BE;EACE,yBAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;ACz0BE;EAAA;IDs2BE,wBAAA;IACA,kBAAA;EAzBF;AACF;AA4BA;EACE,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;UAAA,kBAAA;AA1BF;AC11BE;EAAA;IDu3BE,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,gBAAA;IACA,gBAAA;EAzBF;AACF;ACt1BE;EAAA;IDk3BE,wBAAA;IAAA,+BAAA;YAAA,uBAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;EAxBF;AACF;ACz1BE;EAAA;IDo3BE,YAAA;IACA,eAAA;IACA,8BAAA;IAAA,6BAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,aAAA;EAvBF;AACF;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AAxBF;AC73BE;EAAA;IDw5BE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,sBAAA;IAAA,6BAAA;YAAA,qBAAA;IACA,gBAAA;EAvBF;AACF;ACx3BE;EAAA;IDk5BE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,sBAAA;IAAA,6BAAA;YAAA,qBAAA;IACA,gBAAA;EAtBF;AACF;ACz3BE;EAAA;IDk5BE,cAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,oBAAA;IACA,iBAAA;EArBF;AACF;AAwBA;EACE,cAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAtBF;ACh6BE;EAAA;IDy7BE,mBAAA;IACA,gBAAA;IACA,cAAA;IACA,4BAAA;YAAA,oBAAA;EArBF;AACF;AC55BE;EAAA;IDo7BE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,4BAAA;YAAA,oBAAA;EApBF;AACF;AC95BE;EAAA;IDq7BE,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAnBF;AACF;AAsBA;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;AApBF;AA4BA;EACE,yBAAA;AA1BF;ACh8BE;EAAA;ID89BI,cAAA;EA1BJ;AACF;ACz7BE;EAAA;IDs9BI,cAAA;EAzBJ;AACF;ACx7BE;EAAA;IDo9BI,cAAA;EAxBJ;AACF;AC/8BE;EAAA;ID4+BI,qCAAA;EAzBJ;AACF;ACx8BE;EAAA;IDo+BI,qCAAA;EAxBJ;AACF;ACv8BE;EAAA;IDk+BI,qCAAA;EAvBJ;AACF;AC99BE;EAAA;ID2/BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EAzBJ;AACF;ACx9BE;EAAA;IDo/BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EAxBJ;AACF;ACx9BE;EAAA;IDm/BI,iBAAA;IACA,sBAAA;YAAA,cAAA;EAvBJ;AACF;ACh/BE;EAAA;ID8gCI,yBAAA;IACA,0BAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBAAA;IACA,oBAAA;IACA,mBAAA;EA1BJ;AACF;AC/+BE;EAAA;ID4gCI,yBAAA;IACA,0BAAA;IACA,mBAAA;IACA,gBAAA;IACA,yBAAA;IACA,oBAAA;IACA,mBAAA;EAzBJ;AACF;ACtgCE;EAAA;IDqiCE,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EA3BF;AACF;AChgCE;EAAA;ID8hCE,SAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EA1BF;AACF;AChgCE;EAAA;ID6hCE,SAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EAzBF;AACF;AA4BA;EACE,sBAAA;AA1BF;AC3hCE;EAAA;ID0jCE,aAAA;IACA,WAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EA3BF;AACF;ACthCE;EAAA;IDojCE,SAAA;EA1BF;AACF;ACrhCE;EAAA;IDkjCE,SAAA;EAzBF;AACF;AC5iCE;EAAA;ID2kCE,yBAAA;IAAA,sCAAA;YAAA,8BAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,WAAA;EA3BF;AACF;AAsBA;EAQI,mBAAA;EAAA,sBAAA;UAAA,cAAA;EACA,YAAA;AA3BJ;AAkBA;EAaI,iBAAA;EACA,sBAAA;UAAA,cAAA;AA5BJ;ACrjCE;EAAA;IDslCI,gBAAA;EA7BJ;ECzjCA;ID0lCI,gBAAA;EA9BJ;EC5jCA;ID8lCI,mBAAA;EA/BJ;AACF;ACtkCE;EAAA;ID2mCE,yBAAA;IAAA,2BAAA;YAAA,mBAAA;EAjCF;AACF;AAoCA;EACE,aAAA;AAlCF;AC9kCE;EAAA;IDmnCE,oBAAA;IAAA,qBAAA;IAAA,aAAA;IACA,yBAAA;IAAA,2BAAA;YAAA,mBAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,aAAA;IACA,mBAAA;IAAA,mBAAA;YAAA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,yBAAA;EAjCF;AACF;AC1lCE;EAAA;IDgoCE,iBAAA;EAlCF;AACF;AAuCE;EAAA;IAEI,aAAA;IACA,YAAA;EArCJ;EAkCA;IAOI,mBAAA;IAAA,sBAAA;YAAA,cAAA;IACA,YAAA;EAtCJ;EA8BA;IAYI,gBAAA;EAvCJ;EA2BA;IAgBI,cAAA;IACA,kBAAA;IACA,oBAAA;EAxCJ;EAsBA;IAsBI,kBAAA;IACA,gBAAA;EAzCJ;EAkBA;IA2BI,oBAAA;IACA,cAAA;EA1CJ;EAcA;IAgCI,mBAAA;IAAA,mBAAA;YAAA,WAAA;IACA,cAAA;IACA,uBAAA;IAAA,mCAAA;YAAA,2BAAA;IACA,gBAAA;IACA,yBAAA;EA3CJ;EAOA;IAwCI,iBAAA;EA5CJ;EAIA;IA4CI,mBAAA;EA7CJ;EACA;IAgDI,eAAA;EA9CJ;EAFA;IAoDI,mBAAA;IAAA,sBAAA;YAAA,cAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;EA/CJ;EARA;;IA4DI,eAAA;EAhDJ;EAZA;IAgEI,wBAAA;EAjDJ;EAfA;IAoEI,oBAAA;EAlDJ;AACF;AAsDA;EC3mCE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDumCA,kBAAA;EACA,2BAAA;EAAA,4BAAA;EAAA,oBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,mBAAA;EAAA,sBAAA;UAAA,cAAA;EACA,YAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,sDAAA;EAAA,8CAAA;AA/CF;AAiDE;EACE,aAAA;AA/CJ;AAmDA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAjDF;AAoDA;EACE,cAAA;AAlDF;AAiDA;EAII,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,mCAAA;UAAA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,8EAAA;EACA,oBAAA;AAlDJ;ACpsCE;EAAA;ID2vCI,kBAAA;EAnDJ;AACF;AAuDA;EACE,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;UAAA,cAAA;AArDF;ACrtCE;EAAA;ID+wCE,yBAAA;EAtDF;AACF;AC9sCE;EAAA;IDuwCE,yBAAA;EArDF;AACF;AAyDE;EAAA;IACE,wBAAA;EAtDF;AACF;AAyDA;EACE,aAAA;EC1rCA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EAKA,mBAAA;EACA,kBAAA;EAvDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDuuCA,cAAA;EACA,gBAAA;AA9CF;ACrvCE;EAAA;IDsyCE,oBAAA;IAAA,qBAAA;IAAA,aAAA;EA7CF;AACF;ACxuCE;EAAA;IDwxCE,aAAA;EA5CF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n@header-bg-image: '../../assets/img2/pay_top_main_bg.png';\n@header-bg-source-width: 410;\n@header-bg-source-height: 110;\n@header-bg-bar-height: 104;\n@header-bg-fixed-end: 0.8;\n@header-bg-full-height-ratio: @header-bg-source-height / @header-bg-bar-height;\n@header-bg-left-width-ratio: (@header-bg-source-width * @header-bg-fixed-end) / @header-bg-bar-height;\n@header-bg-seam-overlap: 2px;\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: @z-index-dropdown;\n  overflow: visible;\n  background-color: transparent;\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    pointer-events: none;\n  }\n\n  &::before {\n    left: 0;\n    z-index: 0;\n    background: url(@header-bg-image) left top / auto 100% no-repeat;\n  }\n\n  &::after {\n    right: 0;\n    z-index: 1;\n    background: url(@header-bg-image) no-repeat;\n    background-size: calc(100% / (1 - @header-bg-fixed-end)) 100%;\n    background-position: right top;\n  }\n\n  .mobile({\n    display: flex;\n    align-items: center;\n    height: auto;\n    min-height: 3.125rem; // 50px\n    padding: @spacing-sm 0;\n    overflow: hidden;\n    width: 100%;\n    max-width: 100vw;\n\n    &::before {\n      height: calc(3.125rem * @header-bg-full-height-ratio);\n      width: calc(3.125rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(3.125rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 3.125rem;\n    }\n  });\n\n  .tablet({\n    display: flex;\n    align-items: center;\n    height: 5rem;\n\n    &::before {\n      height: calc(5rem * @header-bg-full-height-ratio);\n      width: calc(5rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(5rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 5.3rem;\n    }\n  });\n\n  .desktop({\n    display: flex;\n    align-items: center;\n    height: 5rem;\n\n    &::before {\n      height: calc(5rem * @header-bg-full-height-ratio);\n      width: calc(5rem * @header-bg-left-width-ratio + @header-bg-seam-overlap);\n    }\n\n    &::after {\n      left: calc(5rem * @header-bg-left-width-ratio - @header-bg-seam-overlap);\n      height: 5.3rem;\n    }\n  });\n}\n\n\n.loginBar {\n  position: relative;\n  background: @background-color; // 灰色背景\n  padding: @spacing-sm;\n  padding-top: 4.375rem; // 70px\n\n  // 平板端不展示 loginBar（商品页等仅在手机端使用的场景由下方 modifier 控制）\n  .tablet({\n    display: none;\n  });\n\n  &.loginBarHiddenOnDesktop {\n    .tablet-up({\n      display: none;\n    });\n  }\n\n  &.loginBarProductsMobileOnly {\n    .tablet-up({\n      display: none;\n    });\n  }\n\n  &.loginBarProductsMobileHidden {\n    .mobile({\n      display: none;\n    });\n  }\n\n  &.loginBarHomeMobileHidden {\n    .mobile({\n      display: none;\n    });\n  }\n  \n  .desktop({\n    position: absolute;\n    top: 14vw;\n    left: 1%;\n    z-index: 999;\n    width: 98%;\n    margin: 0 auto;\n    border-radius: 1rem;\n    box-shadow: @box-shadow-md;\n    display: flex;\n    align-items: center;\n    padding: 0 2rem;\n    padding-top: 0;\n    height: 7rem;\n  });\n}\n\n.loginContent {\n  width: 100%;\n}\n\n.userInfo {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-sm;\n  cursor: pointer;\n\n  .mobile({\n    gap: @spacing-sm;\n  });\n}\n\n.avatar {\n  width: 3rem; // 40px\n  height: 3rem; // 40px\n  border-radius: @border-radius-md; // 方形圆角，不是圆形\n  // background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%); // 橙色渐变背景\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: @box-shadow-sm;\n\n  .mobile({\n    width: 3rem; // 36px\n    height: 3rem; // 36px\n  });\n  .desktop({\n    width: 5rem; \n    height: 5rem; \n    border-radius: 1rem;\n  });\n}\n\n.avatarImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: @border-radius-md;\n}\n\n.avatarPlaceholder {\n  width: 100%;\n  height: 100%;\n  // 占位符样式已在 .avatar 的背景中定义\n}\n\n.userText {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-xs;\n  font-size: @font-size-xs;\n}\n\n.gameNameRow {\n  display: none;\n  \n  .desktop({\n    display: block;\n    font-size: @font-size-md;\n    font-weight: 500;\n    color: @text-color;\n    margin-bottom: @spacing-xs;\n  });\n}\n\n.loginRow {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-xs;\n  width: 100%;\n}\n\n.greetingText {\n  color: @text-color; // 正常字体颜色\n  font-size: @font-size-sm;\n\n  .mobile({\n    font-size: 0.4625rem;\n  });\n}\n\n.loginPromptText {\n  color: @primary-color; // 蓝色字体\n  font-size: @font-size-sm;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.arrowIcon {\n  display: inline-block;\n  width: auto;\n  height: 1em;\n  vertical-align: middle;\n  margin-left: @spacing-xs;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    height: 1rem; // 16px\n    margin-left: 0.25rem; // 4px\n  });\n}\n\n.characterInfo {\n  .flex-start();\n  align-items: center;\n  gap: @spacing-xs;\n  flex-wrap: wrap;\n  font-size: @font-size-sm;\n}\n\n.characterNameLink {\n  color: @primary-color;\n  // font-size: @font-size-xs;\n  cursor: pointer;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: darken(@primary-color, 10%);\n  }\n\n}\n\n.gameServerText {\n  color: @text-color-secondary;\n  font-size: @font-size-sm;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.switchServerButton {\n  .button-reset();\n  .flex-center();\n  padding: 0.125rem @spacing-xs; // 2px\n  background: transparent;\n  border: none;\n  color: @primary-color;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:active {\n    opacity: 0.6;\n  }\n\n  .mobile({\n    padding: 0.0625rem 0.25rem; // 1px 4px\n  });\n}\n\n.container {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n  gap: @spacing-lg;\n\n  .mobile({\n    padding: 0 @spacing-sm;\n    justify-content: space-between;\n    flex: 1;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    align-items: center;\n    gap: 0.375rem;\n  });\n  .tablet({\n    padding: @spacing-md 1.25rem;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n  });\n\n  .desktop({\n    justify-content: space-between;\n    padding: @spacing-lg 1rem;\n    width: 100%;\n  });\n\n}\n\n.logoSection {\n  .flex-start();\n  align-items: center;\n  flex-shrink: 0;\n  min-width: 0;\n\n  .mobile({\n    min-width: 0;\n  });\n}\n\n.logo {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  min-width: 0;\n\n  .mobile({\n    align-items: center;\n    gap: 0.25rem;\n  });\n\n  .tablet({\n    align-items: center;\n  });\n\n  .desktop({\n    gap: 1.5rem;\n  });\n}\n\n.logoIcon {\n  height: 2.25rem;\n  width: auto;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    height: 1.875rem;\n  });\n\n  .tablet({\n    height: 2.25rem;\n  });\n\n  .desktop({\n    height: 4rem;\n  });\n}\n\n.logoTextImg {\n  height: 1.5rem;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    width: 4.263rem;\n    max-width: 4.263rem;\n    height: auto;\n    max-height: 1rem;\n    align-self: flex-start;\n  });\n\n  .tablet({\n    width: 5.61rem;\n    max-width: 5.61rem;\n    height: auto;\n    max-height: 1.25rem;\n    align-self: flex-start;\n  });\n\n  .desktop({\n    width: auto;\n    height: 1.625rem;\n    max-height: none;\n    margin-top: 0;\n    align-self: center;\n  });\n}\n\n.nav {\n  .flex-start();\n  gap: @spacing-lg;\n\n  // 平板和手机端都使用显隐菜单\n  @media (max-width: 1023px) {\n    position: fixed;\n    top: 3.75rem; // 60px\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    background: @white;\n    box-shadow: @box-shadow-md;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    gap: 0;\n    z-index: @z-index-dropdown;\n    padding: @spacing-xs 0;\n\n    &.navOpen {\n      transform: translateX(0);\n    }\n  }\n  // 电脑端隐藏\n  .desktop({\n    display: none;\n  });\n}\n\n.navItem {\n  color: @text-color;\n  text-decoration: none;\n  font-size: @font-size-md;\n  font-family: @font-family-display;\n  transition: color 0.3s ease;\n  .flex-start();\n  align-items: center;\n  gap: @spacing-sm;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  padding: 0;\n\n  &:hover {\n    color: @primary-color;\n  }\n\n  .mobile({\n    text-align: center;\n    margin: 0 auto;\n    border-bottom: 1px solid @border-color;\n    width: 70%;\n    padding: @spacing-md @spacing-lg;\n    .touch-friendly();\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: @font-size-sm;\n    gap: @spacing-md;\n  });\n  .tablet({\n    text-align: center;\n    margin: 0 auto;\n    border-bottom: 1px solid @border-color;\n    width: 70%;\n    padding: @spacing-md @spacing-lg;\n    .touch-friendly();\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: @font-size-sm;\n    gap: @spacing-md;\n  });\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.navIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.25rem; // 20px\n  height: 1.25rem; // 20px\n  color: inherit;\n\n  .mobile({\n    width: 1.25rem; // 20px\n    height: 1.25rem; // 20px\n  });\n}\n\n.navText {\n  flex: 0 0 auto;\n  font-family: @font-family-display;\n}\n\n.actions {\n  .flex-start();\n  gap: @spacing-sm;\n  align-items: center;\n  min-width: 0;\n  flex-shrink: 0;\n\n  .mobile({\n    gap: @spacing-xs;\n    max-width: 48%;\n  });\n}\n\n// PC端导航\n@header-nav-select-image: '../../assets/img2/pay_top_title_select.png';\n\n// 用户下拉（设计稿：深棕底 + 金褐描边/分割线）\n@header-user-dropdown-bg: #3c302a;\n@header-user-dropdown-border: #9c8466;\n@header-user-dropdown-radius: 0.75rem;\n@header-home-dropdown-bg: @header-user-dropdown-bg;\n@header-home-dropdown-border: @header-user-dropdown-border;\n\n.desktopNav {\n  display: none;\n  .flex-start();\n  gap: @spacing-md;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-end;\n  padding-right: @spacing-xl;\n\n  .desktop({\n    display: flex;\n    justify-content: flex-start;\n    margin-left: @spacing-lg;\n  });\n  .tablet({\n    display: flex;\n    justify-content: flex-start;\n    margin-left: @spacing-lg;\n    padding-right: @spacing-md;\n  });\n  .mobile({\n    display: none;\n  });\n}\n\n.desktopNavItem {\n  .button-reset();\n  color: rgba(255, 255, 255, 0.82);\n  font-family: @font-family-display;\n  font-size: @font-size-md;\n  text-decoration: none;\n  padding: 0;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  position: relative;\n  display: inline-block;\n  font-weight: bold;\n  font-size: @font-size-lg;\n  .mobile({\n    display: none;\n  });\n\n  &:hover {\n    color: @primary-color;\n  }\n\n  &.desktopNavItemPlatform {\n    color: #ff6c00;\n    font-size: 1.7rem;\n    margin-right: @spacing-lg;\n\n    .tablet({\n      display: none;\n    });\n\n    .desktop({\n      display: none;\n    });\n\n    &:hover {\n      color: #ff6c00;\n      opacity: 0.9;\n    }\n  }\n\n  &.desktopNavItemTab {\n    &:hover {\n      color: rgba(255, 255, 255, 0.95);\n    }\n\n    &.desktopNavItemActive {\n      color: #feba34;\n\n      &:hover {\n        color: #feba34;\n        opacity: 0.92;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: -0.375rem;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 3.5625rem;\n        height: 0.25rem;\n        background: url(@header-nav-select-image) no-repeat center / contain;\n      }\n    }\n  }\n}\n\n.desktopNavDivider {\n  width: 3px;\n  height: 1.125rem;\n  background: rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n  margin: 0 @spacing-xs;\n  border-radius: 4px;\n}\n\n// PC端登录按钮\n.loginButton {\n  display: none;\n  .button-reset();\n  padding: @spacing-sm @spacing-lg;\n  background-color: #ff8f1d;\n  color: @white;\n  border-radius: 999px;\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: opacity 0.2s ease, background-color 0.2s ease;\n\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n  .desktop({\n    display: block;\n  });\n\n  .tablet({\n    display: block;\n  });\n}\n\n// 用户下拉（PC / 平板 / 手机统一视觉）\n// inline-flex + stretch：触发器与菜单项共用同一列宽，避免子项宽度各算各的\n.userDropdown {\n  display: none;\n  position: relative;\n  min-width: 0;\n  flex-direction: column;\n  align-items: stretch;\n\n  .tablet({\n    display: inline-flex;\n    min-width: 12rem;\n    max-width: 18rem;\n  });\n\n  .desktop({\n    display: inline-flex;\n    min-width: 14rem;\n    max-width: 20rem;\n  });\n}\n\n.userDropdownProductsMobile {\n  .mobile({\n    display: inline-flex;\n    position: relative;\n    max-width: 42vw;\n    min-width: 0;\n  });\n}\n\n.userDropdownHomeMobile {\n  .mobile({\n    display: inline-flex;\n    position: relative;\n    max-width: 48vw;\n    min-width: 0;\n  });\n}\n\n.userDropdownOpen .userDropdownTrigger {\n  border-radius: @header-user-dropdown-radius @header-user-dropdown-radius 0 0;\n  border-bottom-color: transparent;\n}\n\n.userDropdownTrigger {\n  .button-reset();\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.375rem;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.625rem 0.75rem;\n  background-color: @header-user-dropdown-bg;\n  border: 1px solid @header-user-dropdown-border;\n  border-radius: @header-user-dropdown-radius;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: lighten(@header-user-dropdown-bg, 4%);\n  }\n\n  .mobile({\n    padding: 0.5rem 0.625rem;\n    gap: 0.25rem;\n  });\n}\n\n.userEmail {\n  flex: 1;\n  min-width: 0;\n  font-family: @font-family-sans;\n  font-size: @font-size-sm;\n  font-weight: 700;\n  color: @white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n\n  .mobile({\n    font-size: @font-size-xxs;\n  });\n\n  .desktop({\n    font-size: @font-size-md;\n  });\n}\n\n.chevronIcon {\n  flex-shrink: 0;\n  width: 0.875rem;\n  height: 0.875rem;\n  transition: transform 0.2s ease;\n\n  .mobile({\n    width: 0.75rem;\n    height: 0.75rem;\n  });\n}\n\n.chevronIconOpen {\n  transform: rotate(180deg);\n}\n\n// 下拉菜单共用外观（定位由 Docked / Portal 分担）\n.userDropdownMenu {\n  margin-top: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: @header-user-dropdown-bg;\n  border: 1px solid @header-user-dropdown-border;\n  border-top: none;\n  border-radius: 0 0 @header-user-dropdown-radius @header-user-dropdown-radius;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n// 平板及以上：菜单仍在 .userDropdown 内绝对定位，宽度跟触发器\n.userDropdownMenuDocked {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  min-width: 100%;\n  z-index: @z-index-dropdown + 1;\n}\n\n// 手机端挂到 body；禁止 width/min-width:100%（否则会按视口撑满）\n.userDropdownMenuPortal {\n  position: fixed;\n  z-index: @z-index-dropdown + 2;\n  min-width: 0;\n  max-width: none;\n}\n\n.userDropdownDivider {\n  height: 1px;\n  margin: 0;\n  background-color: @header-user-dropdown-border;\n}\n\n.userDropdownItem {\n  .button-reset();\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.625rem 0.75rem;\n  text-align: center;\n  font-family: @font-family-sans;\n  font-size: @font-size-sm;\n  font-weight: 700;\n  color: @white;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: lighten(@header-user-dropdown-bg, 6%);\n  }\n\n  &:active {\n    background-color: lighten(@header-user-dropdown-bg, 10%);\n  }\n\n  .mobile({\n    padding: 0.5rem 0.625rem;\n    font-size: @font-size-xs;\n  });\n}\n\n.logoTextGroup {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: auto;\n  max-width: 4.263rem;\n  min-width: 0;\n  vertical-align: middle;\n  align-self: center;\n\n  .mobile({\n    align-items: flex-start;\n    justify-content: flex-start;\n    height: 1.875rem;\n    text-align: left;\n  });\n\n  .tablet({\n    align-items: flex-start;\n    justify-content: flex-start;\n    height: 2.25rem;\n    text-align: left;\n    max-width: 5.61rem;\n  });\n\n  .desktop({\n    height: auto;\n    max-width: none;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.625rem;\n  });\n}\n\n.logoSubtitleWrap {\n  display: none;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  margin-top: 0.125rem;\n  overflow: visible;\n\n  .mobile({\n    display: flex;\n    align-items: flex-end;\n    margin-top: auto;\n  });\n\n  .tablet({\n    display: flex;\n    align-items: flex-end;\n    margin-top: auto;\n  });\n\n  .desktop({\n    display: block;\n    width: auto;\n    min-width: 0;\n    margin-top: 0;\n    margin-left: 0.75rem;\n    overflow: visible;\n  });\n}\n\n.logoSubtitle {\n  display: block;\n  box-sizing: border-box;\n  max-width: 100%;\n  color: #fa5900;\n  font-family: \"JingNan BoBo Hei\";\n  white-space: nowrap;\n  text-align: left;\n  line-height: 1.15;\n  overflow: visible;\n\n  .mobile({\n    font-size: 0.725rem;\n    font-weight: 700;\n    line-height: 1;\n    align-self: flex-end;\n  });\n\n  .tablet({\n    font-size: @font-size-md;\n    font-weight: 700;\n    line-height: 1.05;\n    align-self: flex-end;\n  });\n\n  .desktop({\n    width: auto;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1.2;\n  });\n}\n\n.logoSubtitleWrapped {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: normal;\n}\n\n@header-home-guest-bg: #1c1611;\n@header-home-guest-orange: #ff8a16;\n@mobile-home-nav-indicator-gap: 0.1875rem;\n@mobile-home-nav-indicator-height: 0.25rem;\n\n.headerHomeMobileDark {\n  background-color: #2c2c2c;\n\n  .mobileHomeNavItemActive {\n    .mobile({\n      color: @header-home-guest-orange;\n    });\n\n    .tablet({\n      color: @header-home-guest-orange;\n    });\n\n    .desktop({\n      color: @header-home-guest-orange;\n    });\n  }\n\n  .mobileHomeNavDivider {\n    .mobile({\n      background: rgba(255, 255, 255, 0.35);\n    });\n\n    .tablet({\n      background: rgba(255, 255, 255, 0.35);\n    });\n\n    .desktop({\n      background: rgba(255, 255, 255, 0.35);\n    });\n  }\n\n\n  .actions {\n    .mobile({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n\n    .tablet({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n\n    .desktop({\n      margin-left: auto;\n      flex-shrink: 0;\n    });\n  }\n}\n\n.headerHomeGuestMobile {\n  .loginButton {\n    .mobile({\n      display: block !important;\n      padding: 0.375rem 1.125rem;\n      font-size: @font-size-xs;\n      font-weight: 700;\n      background-color: @header-home-guest-orange;\n      border-radius: 999px;\n      white-space: nowrap;\n    });\n\n    .tablet({\n      display: block !important;\n      padding: 0.4375rem 1.25rem;\n      font-size: @font-size-sm;\n      font-weight: 700;\n      background-color: @header-home-guest-orange;\n      border-radius: 999px;\n      white-space: nowrap;\n    });\n  }\n}\n\n.containerHomeMobileDark {\n  .mobile({\n    gap: 0.625rem;\n    align-items: center;\n  });\n\n  .tablet({\n    gap: @spacing-md;\n    align-items: center;\n  });\n\n  .desktop({\n    gap: @spacing-md;\n    align-items: center;\n  });\n}\n\n.headerHomeMobile {\n  background-color: #000;\n}\n\n.containerHomeMobile {\n  .mobile({\n    gap: 0.825rem;\n    width: 100%;\n    align-items: center;\n  });\n\n  .tablet({\n    gap: @spacing-md;\n  });\n\n  .desktop({\n    gap: @spacing-md;\n  });\n}\n\n// 无顶栏 inline 导航：logo 与 actions 左右两端对齐，保留常规 logo 尺寸\n.containerHomeMobileNoInlineNav {\n  .mobile({\n    justify-content: space-between;\n    align-items: center;\n    gap: @spacing-sm;\n  });\n\n  .logoSection {\n    flex: 0 1 auto;\n    min-width: 0;\n  }\n\n  .actions {\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  .mobileNarrow({\n    .logoIcon {\n      height: 1.875rem;\n    }\n\n    .logoTextImg {\n      max-height: 1rem;\n    }\n\n    .logoSubtitle {\n      font-size: 0.625rem;\n    }\n  });\n}\n\n.headerHomeMobileNoInlineNav {\n  .mobile({\n    align-items: center;\n  });\n}\n\n.mobileHomeNav {\n  display: none;\n\n  .mobile({\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 0.575rem;\n    flex: 1 1 0;\n    min-width: 0;\n    overflow: hidden;\n    padding-bottom: @mobile-home-nav-indicator-gap + @mobile-home-nav-indicator-height;\n  });\n}\n\n.mobileHomeNavNoActive {\n  .mobile({\n    padding-bottom: 0;\n  });\n}\n\n// ≤399px：为 userDropdown 预留空间，避免与 inline 导航互相遮挡；>400px 保持原样式\n.headerWithMobileHomeNav {\n  @media (max-width: 399px) {\n    .container {\n      gap: 0.575rem;\n      min-width: 0;\n    }\n\n    .logoSection {\n      flex: 0 0 auto;\n      min-width: 0;\n    }\n\n    .logoIcon {\n      height: 1.625rem;\n    }\n\n    .logoTextImg {\n      width: 3.73rem;\n      max-width: 3.73rem;\n      max-height: 0.875rem;\n    }\n\n    .logoTextGroup {\n      max-width: 3.73rem;\n      height: 1.625rem;\n    }\n\n    .logoSubtitle {\n      font-size: 0.5625rem;\n      line-height: 1;\n    }\n\n    .mobileHomeNav {\n      flex: 1 1 0;\n      gap: 0.6125rem;\n      justify-content: flex-start;\n      overflow: hidden;\n      padding-bottom: @mobile-home-nav-indicator-gap + @mobile-home-nav-indicator-height;\n    }\n\n    .mobileHomeNavNoActive {\n      padding-bottom: 0;\n    }\n\n    .mobileHomeNavItem {\n      font-size: 0.625rem;\n    }\n\n    .mobileHomeNavDivider {\n      height: 0.75rem;\n    }\n\n    .actions {\n      flex: 0 0 auto;\n      margin-left: auto;\n      min-width: 0;\n      max-width: 42%;\n    }\n\n    .userDropdownHomeMobile,\n    .userDropdownProductsMobile {\n      max-width: 100%;\n    }\n\n    .userDropdownTrigger {\n      padding: 0.375rem 0.5rem;\n    }\n\n    .userEmail {\n      font-size: 0.5625rem;\n    }\n  }\n}\n\n.mobileHomeNavItem {\n  .button-reset();\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: calc((100% - 0.25rem - 1px) / 2);\n  color: @white;\n  font-size: @font-size-xs;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: opacity 0.2s ease, color 0.2s ease;\n\n  &:hover {\n    opacity: 0.85;\n  }\n}\n\n.mobileHomeNavItemText {\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n  min-width: 0;\n  overflow: visible;\n  white-space: nowrap;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.mobileHomeNavItemActive {\n  color: @header-home-guest-orange;\n\n  .mobileHomeNavItemText::after {\n    content: '';\n    position: absolute;\n    bottom: -0.3375rem;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: @mobile-home-nav-indicator-height;\n    background: url(@header-nav-select-image) no-repeat center / contain;\n    pointer-events: none;\n  }\n\n  .mobileNarrow({\n    .mobileHomeNavItemText::after {\n      bottom: -(@mobile-home-nav-indicator-gap + @mobile-home-nav-indicator-height);\n    }\n  });\n}\n\n.mobileHomeNavDivider {\n  width: 1px;\n  height: 0.875rem;\n  background: rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n}\n\n.loginButtonMobileHome {\n  .mobile({\n    display: block !important;\n  });\n\n  .tablet({\n    display: block !important;\n  });\n}\n\n.menuButtonHomeHidden {\n  @media (max-width: 1023px) {\n    display: none !important;\n  }\n}\n\n.menuButton {\n  display: none;\n  .button-reset();\n  .touch-friendly();\n  .flex-center();\n  color: @white;\n  padding: @spacing-xs;\n\n  .mobile({\n    display: flex;\n  });\n\n  .desktop({\n    display: none;\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n// 可滚动弹窗蒙版：背景 fixed 铺满视口，内容区单独滚动，避免移动端滑出未覆盖区域\n.modalOverlayBackdrop(@bg: rgba(0, 0, 0, 0.55)) {\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  touch-action: pan-y;\n\n  &::before {\n    content: '';\n    position: fixed;\n    inset: 0;\n    background: @bg;\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: -1;\n    pointer-events: none;\n  }\n}\n\n// 触屏设备横屏时高度很矮，弹窗蒙版必须允许自身滚动，并从顶部开始排布。\n.touchLandscapeModalOverlay(@padding-y: @spacing-sm, @padding-x: @spacing-md) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    display: block;\n    align-items: initial;\n    justify-content: initial;\n    padding: @padding-y @padding-x;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-y;\n\n    &::after {\n      content: '';\n      display: block;\n      height: @padding-y;\n    }\n  }\n}\n\n.touchLandscapeModalBox(@max-height-gap: (@spacing-sm * 2)) {\n  @media (hover: none) and (pointer: coarse) and (orientation: landscape) {\n    max-height: calc(var(--app-viewport-height, 100dvh) - @max-height-gap);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `slSYbgCh`,
	"loginBar": `VjeZst5L`,
	"loginBarHiddenOnDesktop": `z8MR9HQQ`,
	"loginBarProductsMobileOnly": `dG2Qxs0k`,
	"loginBarProductsMobileHidden": `a_eZ1XUE`,
	"loginBarHomeMobileHidden": `yb7OA2X7`,
	"loginContent": `BtEycIWT`,
	"userInfo": `Y4OQJmfp`,
	"avatar": `zHIhM57O`,
	"avatarImage": `OTNvIQ1p`,
	"avatarPlaceholder": `GDmL5IO3`,
	"userText": `sVB5c3uo`,
	"gameNameRow": `WfBlVulO`,
	"loginRow": `qN8X9qUM`,
	"greetingText": `o75QkgKG`,
	"loginPromptText": `d5JyeBW_`,
	"arrowIcon": `p7ZdYuU7`,
	"characterInfo": `iJmvZ14p`,
	"characterNameLink": `SGn_HB4s`,
	"gameServerText": `GwNgdG1L`,
	"switchServerButton": `sLKWM0Wj`,
	"container": `UA1ikLgE`,
	"logoSection": `_fyIi7KJ`,
	"logo": `sbCrta3X`,
	"logoIcon": `bPFeSkuu`,
	"logoTextImg": `aYCUJo6Z`,
	"nav": `YEXthgKT`,
	"navOpen": `Mg_ORDaH`,
	"navItem": `NRbCIQNp`,
	"navIcon": `o_dTFhV5`,
	"navText": `s4NCMenQ`,
	"actions": `WxmOruAL`,
	"desktopNav": `TWzNkum5`,
	"desktopNavItem": `Cfpkiz5W`,
	"desktopNavItemPlatform": `x1_I8CNw`,
	"desktopNavItemTab": `_9tAt3YC`,
	"desktopNavItemActive": `BY_mTe0r`,
	"desktopNavDivider": `UELox73u`,
	"loginButton": `YxQQ0tvE`,
	"userDropdown": `DrhfkESi`,
	"userDropdownProductsMobile": `ACcRgdGU`,
	"userDropdownHomeMobile": `BZjvUcHB`,
	"userDropdownOpen": `onBSJRgN`,
	"userDropdownTrigger": `amrPemvn`,
	"userEmail": `FX3bc5nT`,
	"chevronIcon": `DFFBVVPO`,
	"chevronIconOpen": `LnJ91sL2`,
	"userDropdownMenu": `gr1jL_46`,
	"userDropdownMenuDocked": `ks3Nw2XX`,
	"userDropdownMenuPortal": `eTBjKnGi`,
	"userDropdownDivider": `NNNXQaBb`,
	"userDropdownItem": `DB7hJh15`,
	"logoTextGroup": `ct51z5xU`,
	"logoSubtitleWrap": `CMWFVjrY`,
	"logoSubtitle": `SaCm9NPx`,
	"logoSubtitleWrapped": `AGbYZKGl`,
	"headerHomeMobileDark": `jMVNYpxK`,
	"mobileHomeNavItemActive": `o6H1hQYt`,
	"mobileHomeNavDivider": `ucMM2ewT`,
	"headerHomeGuestMobile": `eEHixaFV`,
	"containerHomeMobileDark": `EI64mGw6`,
	"headerHomeMobile": `FjAMRuJf`,
	"containerHomeMobile": `tflBBnun`,
	"containerHomeMobileNoInlineNav": `e9m4cALT`,
	"headerHomeMobileNoInlineNav": `LfDJxVwX`,
	"mobileHomeNav": `bgBpjEza`,
	"mobileHomeNavNoActive": `l4s972Zf`,
	"headerWithMobileHomeNav": `bnA1G1WJ`,
	"mobileHomeNavItem": `TpiKZ7KT`,
	"mobileHomeNavItemText": `Okp1w76E`,
	"loginButtonMobileHome": `WcW8I6HY`,
	"menuButtonHomeHidden": `kcKlUkRc`,
	"menuButton": `FmYnbzty`
};
export default ___CSS_LOADER_EXPORT___;
